var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_37",
    "data-name": "Grupo 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.198,
    height: 164.535,
    viewBox: "0 0 169.198 164.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_85",
    "data-name": "Ret\\xE2ngulo 85",
    width: 169.198,
    height: 164.535,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M36.246,50.918l10.49,20.663a11.767,11.767,0,1,1-21,10.629L13.21,57.4",
    transform: "translate(19.681 75.859)",
    fill: "#fc5689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M59.233,17.307S30.784,50.915,11.839,63.9c-9.87,6.765-13.49,19-8.07,29.669s17.265,13.532,28.79,10.318c9.793-2.734,29.7-9.668,60.762-8.291",
    transform: "translate(1.863 25.784)",
    fill: "none",
    stroke: "#411172",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202",
    "data-name": "Caminho 202",
    d: "M80.064,45.379C89.759,67.7,85.609,91,70.794,97.441S36.105,91.008,26.41,68.691s-5.547-45.624,9.27-52.063S70.368,23.062,80.064,45.379Z",
    transform: "translate(31.541 22.302)",
    fill: "none",
    stroke: "#411172",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_10",
    "data-name": "Linha 10",
    y1: 7.477,
    x2: 26.33,
    transform: "translate(53.322 67.541)",
    fill: "none",
    stroke: "#411172",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_11",
    "data-name": "Linha 11",
    y1: 16.988,
    x2: 22.187,
    transform: "translate(68.508 90.71)",
    fill: "none",
    stroke: "#411172",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_203",
    "data-name": "Caminho 203",
    d: "M45.659,1.25s67.41,21.5,49.314,99.2",
    transform: "translate(68.025 1.861)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_204",
    "data-name": "Caminho 204",
    d: "M42.3,10.667C54.093,13.916,66.064,25.21,73,41.18c5.582,12.848,6.73,26.014,4.009,36.317",
    transform: "translate(63.015 15.891)",
    fill: "none",
    stroke: "#411172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_205",
    "data-name": "Caminho 205",
    d: "M50.76,36.771c3.521,8.1,2.014,16.57-3.366,18.908s-12.6-2.338-16.119-10.442S29.26,28.669,34.64,26.331s12.6,2.335,16.119,10.44",
    transform: "translate(43.76 38.331)",
    fill: "#fc5689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_206",
    "data-name": "Caminho 206",
    d: "M48.454,36.1c3.035,6.987,1.735,14.284-2.9,16.3s-10.858-2.014-13.893-9-1.735-14.282,2.9-16.3S45.418,29.109,48.454,36.1Z",
    transform: "translate(44.722 39.593)",
    fill: "none",
    stroke: "#411172",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.0da494943ae6910c2943800f6e05afe9.svg";
export { ForwardRef as ReactComponent };